module.exports = __webpack_public_path__ + "img/body-lung.035beb8.svg";